import React, { useState, useEffect } from "react";
import { Col, Container, Row, Table, } from "react-bootstrap";
import { Link } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import { useNavigate } from "react-router";
import Header from "../../Component/Header";
import FullScreenLoader from "../../Component/Loader";
import { getAppList } from "../../Services/home.js";

import "./style.css"

import userManageIcon from "../../Asset/Img/user-management-icon.svg";
import shippingIcon from "../../Asset/Img/shipping-receive-icon.svg";
import priceBookIcon from "../../Asset/Img/pricebook-icon.svg";
import { alignPropType } from "react-bootstrap/esm/types.js";

function Home() {
  const navigate = useNavigate();
  const [showLoader, setShowLoader] = useState(false);
  const [applications, setApplications] = useState([]);

  useEffect(() => {
    fetchAppList()
  }, []);

  let fetchAppList = async () => {
    setShowLoader(true)
    let data = await getAppList(localStorage?.access_token)
    if (data?.data?.status_code == 200) {
      setApplications(data?.data?.applications)
    }
    setShowLoader(false)
  }

  let handleView = (app) => {
    let url = `${app}?access_token=${localStorage.access_token}`
    window.open(url, '_blank', 'noopener,noreferrer');
  }

  return (
    <div className="wrapper">
      {showLoader ? <FullScreenLoader></FullScreenLoader> : null}
      <ToastContainer />
      <Header />
      <div className="top-heading-contain">
        <Container fluid className="container-space-side">
          <Row>
            <Col xs={12}>
              <div className="heading-hm">
                <h1 className="title-home-pg">👋🏼 Hello, Welcome!</h1>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
      <div class="container-layout py-5">
        <Container fluid>
          <Row>
            {
              applications.length ?
                applications.map((val, i) => {
                  return (
                    <Col key={i} xs={12} md={4} lg={3}>
                      <div className="card-box-service-hm">
                        <div className="column-contain-wts">
                          <div className="flx-mange-wgt">
                            <div className="left-icon-flx">
                              <span className="icon-elmt-wt">
                                <i className="far fa-user"></i>
                              </span>
                            </div>
                            <div className="right-text-flx">
                              <h3 className="title-hm-h3">{val.ApplicationName}</h3>
                            </div>
                          </div>
                          <p className="short-line-hm">{val.Description}</p>
                        </div>
                        <div onClick={() => handleView(val.WebsiteLink)} className="bottom-area-yt">
                          <Link className="link-more-txt">View</Link>
                        </div>
                      </div>
                    </Col>
                  )
                })
                : null
            }

          </Row>
        </Container>
      </div>
    </div>
  );
}

export default Home;
